const DEV_MODE = false;
const API_BASE = process.env.REACT_APP_API_BASE || "https://studiosvc.norcat.org";

const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());

export class FormSubmitter {
  constructor({
    endpoint = `${API_BASE}/api/newsletter`,
    defaultHeaders = {},
    timeoutMs = 12000,
  } = {}) {
    this.endpoint = endpoint;
    this.defaultHeaders = defaultHeaders;
    this.timeoutMs = timeoutMs;
  }

  validateEmail(email) {
    const value = String(email || "").trim();
    if (!value) return { ok: false, message: "Email is required." };
    if (!isEmail(value)) return { ok: false, message: "Please enter a valid email." };
    return { ok: true, message: "" };
  }

  async submitEmail(email, meta = {}, { endpoint, headers } = {}) {
    const validation = this.validateEmail(email);
    if (!validation.ok) {
      const err = new Error(validation.message);
      err.code = "VALIDATION";
      throw err;
    }

    const url = endpoint || this.endpoint;
    const payload = {
      kind: "newsletter",
      fields: { email: String(email || "").trim() },
      meta: {
        createdAt: new Date().toISOString(),
        page: typeof window !== "undefined" ? window.location.pathname : "",
        ...meta,
      },
    };

    // Dev Testing
    if (DEV_MODE) {
      await new Promise((r) => setTimeout(r, 300));
      return { ok: true };
    }

    // timeout support
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), this.timeoutMs);

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...this.defaultHeaders,
          ...(headers || {}),
        },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });

      if (!res.ok) {
        let message = "Subscription failed. Please try again.";
        try {
          const data = await res.json();
          if (data?.message) message = data.message;
        } catch {}
        throw new Error(message);
      }

      return res.json().catch(() => ({ ok: true }));
    } catch (e) {
      if (e?.name === "AbortError") throw new Error("Request timed out. Please try again.");
      throw e;
    } finally {
      clearTimeout(t);
    }
  }
}

export const newsletterSubmitter = new FormSubmitter({
  endpoint: `${API_BASE}/api/newsletter`,
});
